import { render } from "./ItemShelf.vue?vue&type=template&id=3a14e952&scoped=true"
import script from "./ItemShelf.vue?vue&type=script&lang=js"
export * from "./ItemShelf.vue?vue&type=script&lang=js"

import "./ItemShelf.vue?vue&type=style&index=0&id=3a14e952&scoped=true&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/magic-shop-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a14e952"]])

export default __exports__